import enc from 'crypto-js/enc-utf16';
import SHA1 from 'crypto-js/sha1';
import TripleDES from 'crypto-js/tripledes';

export class Simple3Des {
    private key: any = null;
    private iv: any = null;

    constructor(key: string) {
        // 24 came as an output from Console.WriteLine(TripleDes.KeySize \ 8) VB constructor code
        this.key = this.truncateHash(key, 24);
        // 8 from Console.WriteLine(TripleDes.BlockSize \ 8)
        this.iv = this.truncateHash('', 8);
    }

    public encryptData(data): string {
        // Convert to Utf16LE, encrypt and encode in Base64

        const ret = TripleDES.encrypt(enc.parse(data), this.key, { iv: this.iv }).ciphertext.toString();
        return ret;
    }

    private truncateHash(key, length) {
        // .Net uses Utf16LE as default encoding
        const ret: any = SHA1(enc.parse(key));
        // Truncate key if necessary
        while (ret.sigBytes > length) {
            delete ret.words[ret.words.length - 1];
            ret.sigBytes -= 4;
        }

        // Expand key if necessary
        while (ret.sigBytes < length) {
            ret.words[ret.words.length] = 0;
            ret.sigBytes += 4;
        }
        return ret;
    }
}
